// Module
var code = "<div id=AlertBox class=\"alert-box radius alert\" ng-if=\"logErrors.errors && logErrors.errors.length > 0\"> <span ng-repeat=\"error in logErrors.errors\">{{error}}</span> </div> ";
// Exports
module.exports = code;